import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMembersItem } from "./redux/slices/MembersThunks";
import { uploadImage } from "./redux/slices/VendorsonhomeThunks";

export default function ModalAdminmemberstwo({
  onClose,
  data,
  setData,
  setOldData,
  oldData,
}) {
  const dispatch = useDispatch();

  const images = [
    "https://d3nakrlcog1u3z.cloudfront.net/1749727331461-4ba31f443c5925758c3d2520e8dd101288b7e192.png",
    "https://d3nakrlcog1u3z.cloudfront.net/1749727392815-8f2345c2608775537665ca7281faf60fab660156.png",
    "https://d3nakrlcog1u3z.cloudfront.net/1749727414680-96ad668930fe16e86e392dba572555141803ed35.png",
    "https://d3nakrlcog1u3z.cloudfront.net/1749727439835-12376cac5a1f7b7847fefa58e81b21fb425cf4cd.png",
    "https://d3nakrlcog1u3z.cloudfront.net/1749727454290-f2eff8c225ba3e0f76746b5e4d09bbc23a4e177a.png",
  ];
  const [selectedImage, setSelectedImage] = useState(
    data?.profile_picture || images[0]
  );

  const handleFieldChange = async (key, value) => {
    try {
      const res = await dispatch(uploadImage(value));
      const url = res.payload.fileURL;

      setSelectedImage(url);

      setData((prev) => setNestedValue({ ...prev }, key, url));
    } catch (e) {
      console.log(e, "error");
    }
  };

  const setNestedValue = (obj, path, value) => {
    const keys = path.split(".");
    const lastKey = keys.pop();
    const lastObj = keys.reduce(
      (acc, key) => (acc[key] = { ...acc[key] }),
      obj
    );
    lastObj[lastKey] = value;
    return { ...obj };
  };

  const handleSave = async () => {
    const date = Date.now();
    const newData = {
      _id: data._id,
      profile_picture: data?.account_id?.profile_picture,
    };
    await dispatch(updateMembersItem(newData));
    setOldData(data);
    onClose();
  };


  useEffect(() => {
    setData({ ...data, profile_picture: images[0] });
  }, []);


  return (
    <RootWrapperModalAdminmemberstwo>
      <AdminMembers07>
        <Wrapper>
          <Profilepicture>
            <Frame1572>
              <Frame1572_0001>
                <SelectAProfilePicture>
                  Choose your profile picture
                </SelectAProfilePicture>
              </Frame1572_0001>
            </Frame1572>
            <Frame1570>
              {images.map((val, idx) => {
                return (
                  <Picture
                    onClick={() => {
                      setSelectedImage(val);
                      setData((prev) => ({
                        ...prev,
                        account_id: {
                          ...prev.account_id,
                          profile_picture: val,
                        },
                      }));
                    }}
                    style={{
                      border:
                        selectedImage == val
                          ? "solid 2px rgba(66, 149, 254, 0.7)"
                          : "solid 2px rgba(136, 136, 136, 0.1)",
                    }}
                  >
                    <Image21
                      style={{
                        width: "120px",
                        height: "120px",
                        background: `url(${val})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </Picture>
                );
              })}
            </Frame1570>
            <Frame1572>
              <Frame1572_0001>
                <SelectAProfilePicture>
                  or upload your profile picture
                </SelectAProfilePicture>
              </Frame1572_0001>
            </Frame1572>
            <PRTNR.FileInput
              label={"Upload Image"}
              helpText={"JPG, GIF or PNG. Max size 800K"}
              accept=".jpg,.jpeg,.gif,.png"
              onChange={(e) => {
                if (e) {
                  handleFieldChange("account_id.profile_picture", e);
                } else {
                  console.log("No file selected");
                }
              }}
              value={data.profile_picture}
            />
            <Frame1571>
              <AIMEButton
                size="small"
                onClick={() => {
                  handleSave();
                }}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: "none",
                  gap: "10px",
                  borderRadius: "48px",
                  width: "240px",
                  background: "rgb(33, 37, 67)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "16px 32px",
                }}
              >
                <span
                  style={{
                    color: "white",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "600",
                    lineHeight: "110%",
                    textAlign: "left",
                  }}
                >
                  Save
                </span>
              </AIMEButton>
            </Frame1571>
          </Profilepicture>
        </Wrapper>
      </AdminMembers07>
    </RootWrapperModalAdminmemberstwo>
  );
}

const RootWrapperModalAdminmemberstwo = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;

  box-sizing: border-box;
`;

const AdminMembers07 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 32px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 40px 24px 24px;
  flex-shrink: 0;
`;
const Profilepicture = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1572 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1572_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 912px;
  box-sizing: border-box;
`;

const SelectAProfilePicture = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  width: 914px;
  flex: 1;
`;

const Frame1570 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 40px 0px;
  flex-shrink: 0;
`;

const Picture = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  border-radius: 220px;
  box-sizing: border-box;
  padding: 8px;
  cursor: pointer;
`;

const Image21 = styled.div`
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;



const Frame1571 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

